module.exports = __webpack_public_path__ + "static/img/leaders_arrow.4de7e6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fanclub/leaders_arrow.png
// module id = ziT0
// module chunks = 7